module.exports = __webpack_public_path__ + "static/img/user-comment8.37c44e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment8.png
// module id = THIU
// module chunks = 0